import * as React from 'react';
import Server from 'src/new/server/Server';
import ResultList from './ResultList';
import Search from './Search';
import SearchResult from './SearchResult';

interface State {
    results: SearchResult[];
    query: string;
}

export default class LexiconApp extends React.Component<{}, State> {

    constructor(props: {}) {
        super(props);
        this.state = {
            results: [],
            query: ''
        };
        this.onSearchQuery = this.onSearchQuery.bind(this);
    }

    public render(): React.ReactNode {
        return (
            <div>
                <Search onQuery={this.onSearchQuery} />
                <ResultList results={this.state.results} query={this.state.query} />
            </div>
        );
    }

    private async onSearchQuery(query: string): Promise<void> {
        query = encodeURIComponent(query);
        const results = await Server.newRequest().get<SearchResult[]>(`lexiconapp/search/${query}`);
        this.setState({ results, query });
    }
}
